import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const TitleColumns = () => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignY="center" alignX="left">
            <I18n component="span" id="echeq.accept.return.endorser" defaultValue="Endosante" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1} alignY="center" alignX="left">
            <I18n component="span" id="echeq.accept.return.cuit" defaultValue="Cuit" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1} alignY="center" alignX="center">
            <I18n component="span" id="echeq.accept.return.date" defaultValue="Fecha" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1} alignY="center" alignX="left">
            <I18n component="span" id="echeq.accept.return.status" defaultValue="Estado" />
        </GridTable.Data>
        {/* <GridTable.Data /> */}
    </>
);
export default TitleColumns;
